export enum CreateAccountStatus {
  Success = 0,
  UsernameAlreadyInUse = 1,
  PasswordInvalid = 2,
  GenericError = 3
}
